import { render } from "./Defaults.vue?vue&type=template&id=ed9a7a56"
import script from "./Defaults.vue?vue&type=script&lang=js"
export * from "./Defaults.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__